import Vue from 'vue'
import { somenteNumeros, somenteNumerosELetras, validaTeclas } from './global'
import { formataCpf, formataCnpj, formataCpfCnpj } from '../../functions/numero'

const limiteCpf = 14
const limiteCnpj = 18

// Remove listeners salvos em `el[chave]` (registrados no `inserted`)
// para evitar acúmulo quando o Vue reaproveita o mesmo elemento entre
// alternâncias de v-if (ex.: CPF <-> CNPJ).
const removeHandlers = (el, chave) => {
    const handlers = el[chave]
    if (!handlers) return
    handlers.forEach(({ evento, fn, capture }) => {
        el.removeEventListener(evento, fn, capture)
    })
    delete el[chave]
}

Vue.directive('mascara-cpf', {
    inserted: function (el) {
        el.maxLength = limiteCpf
        const handlers = [
            { evento: 'keypress', capture: true,  fn: (e) => somenteNumeros(e) },
            { evento: 'focus',    capture: true,  fn: () => el.setAttribute('placeholder', '___.___.___-__') },
            { evento: 'blur',     capture: true,  fn: () => el.setAttribute('placeholder', '') },
            { evento: 'keyup',    capture: true,  fn: (e) => { if (validaTeclas(e)) { e.target.value = formataCpf(e.target.value) } } },
            { evento: 'change',   capture: false, fn: (e) => { e.target.value = formataCpf(e.target.value) } }
        ]
        handlers.forEach(({ evento, fn, capture }) => el.addEventListener(evento, fn, capture))
        el._mascaraCpfHandlers = handlers
    },
    unbind: function (el) {
        removeHandlers(el, '_mascaraCpfHandlers')
    }
})

Vue.directive('mascara-cnpj', {
    inserted: function (el) {
        el.maxLength = limiteCnpj
        const handlers = [
            { evento: 'keypress', capture: true,  fn: (e) => somenteNumerosELetras(e) },
            { evento: 'focus',    capture: true,  fn: () => el.setAttribute('placeholder', '__.___.___/____-__') },
            { evento: 'blur',     capture: true,  fn: () => el.setAttribute('placeholder', '') },
            { evento: 'keyup',    capture: true,  fn: (e) => { if (validaTeclas(e)) { e.target.value = formataCnpj(e.target.value) } } },
            { evento: 'change',   capture: false, fn: (e) => { e.target.value = formataCnpj(e.target.value) } }
        ]
        handlers.forEach(({ evento, fn, capture }) => el.addEventListener(evento, fn, capture))
        el._mascaraCnpjHandlers = handlers
    },
    unbind: function (el) {
        removeHandlers(el, '_mascaraCnpjHandlers')
    }
})

Vue.directive('mascara-cpf-cnpj', {
    inserted: function (el) {
        el.maxLength = limiteCnpj
        const handlers = [
            { evento: 'keypress', capture: true,  fn: (e) => somenteNumerosELetras(e) },
            { evento: 'focus',    capture: true,  fn: () => el.setAttribute('placeholder', '___.___.___-__') },
            { evento: 'blur',     capture: true,  fn: () => el.setAttribute('placeholder', '') },
            { evento: 'keyup',    capture: true,  fn: (e) => { e.target.value = formataCpfCnpj(e.target.value) } },
            { evento: 'change',   capture: false, fn: (e) => { e.target.value = formataCpfCnpj(e.target.value) } }
        ]
        handlers.forEach(({ evento, fn, capture }) => el.addEventListener(evento, fn, capture))
        el._mascaraCpfCnpjHandlers = handlers
    },
    unbind: function (el) {
        removeHandlers(el, '_mascaraCpfCnpjHandlers')
    }
})
